// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2bYr8","content":"LayoutSettings_content__1mXx9"};